import { render, staticRenderFns } from "./projectTree.vue?vue&type=template&id=c01f8d04&scoped=true&"
import script from "./projectTree.vue?vue&type=script&lang=js&"
export * from "./projectTree.vue?vue&type=script&lang=js&"
import style0 from "./projectTree.vue?vue&type=style&index=0&id=c01f8d04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01f8d04",
  null
  
)

export default component.exports